"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
// All classes are used, dynamically
// eslint-disable-next-line css-modules/no-unused-class
const Toast_module_css_1 = __importDefault(require("./Toast.module.css"));
const clsx_1 = __importDefault(require("clsx"));
/**
 * Display a notification message that slides down from the top of the screen and then back up after
 * a brief delay
 */
function Toast({ level, children }) {
    const [isDismissed, setIsDismissed] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => {
            setIsDismissed(true);
        }, 4000);
        return () => {
            clearTimeout(timer);
        };
    }, []);
    if (isDismissed) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(Toast_module_css_1.default.toastContainer, Toast_module_css_1.default[level]), "data-testid": "toastContainer", children: children }));
}
exports.Toast = Toast;
//# sourceMappingURL=index.js.map